import React from "react";
import { PaginationProps, Select, Space, Table, Tag } from "antd";
import { Link } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiDownload } from "@mdi/js";
import B2C2BApi from "../../api-services/b2c2b-api.service";
import { Booking } from "../../interfaces/booking.interface";

const { Column } = Table;
const LIMIT = 25;
const itemRender: PaginationProps['itemRender'] = (_, type, originalElement) => {
  if (type === 'prev') {
    return <a>Previous</a>;
  }
  if (type === "next") {
    return <a>Next</a>;
  }
  return originalElement;
};

const categoriesColor = { "3 to G": "#6BDF63", "8 / 18": "#23D1C0" };
const statusesColor = {
  Awaiting: "#FFBE3D",
  Cancelled: "#ACACAC",
  Paid: "#6BDF63",
};

interface IBookingsPage {
  total: number,
  bookings: Booking[],
  currentPage: number
}

class BookingsPage extends React.Component {
  state:IBookingsPage = {
    total: 0,
    bookings: [],
    currentPage: 1
  }

  componentDidMount(): void {
   this.getBookings();
  }

  getBookings(page=1){
    B2C2BApi.getBookings(LIMIT, page)
      .then(res => {
        if(res.bookings.length > 0){
          const bookings = res.bookings.map((booking, index) => ({...booking, key: index}));
          this.setState({bookings, total: res.total})
        }
        this.setState({currentPage: page})
      })
  }

  handlePageChange = (page) => {
    this.getBookings(page);
  }
  

  render() {
    const { bookings } = this.state;

    return (
      <div id="series-bookings" className="bookings-page b2c2b">
        <div className="bookings-page_header">
          <h1>TravelB2B</h1>
          {/* <div className="bookings-page_header-actions">
            <Icon className="notifications" path={mdiBellBadgeOutline} size="19px" />
            <Select
              variant="borderless"
              style={{ flex: 1 }}
              defaultValue={1}
              suffixIcon={<Icon path={mdiMenuDown} size="19px"/>}
              options={[
                { value: 1, label: 'polytravels' }
              ]}
            />
          </div> */}
        </div>
        <div className="bookings-page_table b2c2b-section_panel">
          <label>Series Bookings</label>
          <Table dataSource={bookings}
                scroll={{ x: 'max-content' }}
                pagination={{
                  position: ["none", "bottomCenter"], 
                  pageSize: LIMIT,
                  total: this.state.total, 
                  showSizeChanger: false,
                  itemRender: itemRender,
                  onChange: this.handlePageChange 
                }}>
            <Column title="Booking Date" dataIndex="bookingDate" key="bookingDate" />
            <Column title="Ref No." dataIndex="refNo" key="refNo" />
            <Column title="Name" dataIndex="name" key="name" />
            <Column title="Booked by" dataIndex="bookedBy" key="bookedBy" />
            <Column
              title="Tour Code"
              dataIndex="tourCode"
              key="tourCode"
              render={(tourCode: string, record) => (
                <>
                  <span>{tourCode} </span>
                  {/* {
                    record.tourCategory.map(category => (
                      <Tag color={categoriesColor[category]} key={category}>
                        {category}
                      </Tag>
                    ))
                  } */}
                </>
              )}
            />
            <Column title="Pax" dataIndex="pax" key="pax" />
            <Column
              title="Destination"
              dataIndex="destination"
              key="destination"
            />
            <Column
              title="Package Name"
              dataIndex="packageName"
              key="packageName"
            />
            <Column
              title="Itinerary"
              dataIndex="itinerary"
              key="itinerary"
              render={(_: string, record) => (
                <>
                  <a href={record.fileUrlCopy} download>
                    EN
                  </a>{" "}
                  |{" "}
                  <a href={record.fileCNUrlCopy} download>
                    CN
                  </a>
                </>
              )}
            />
            {bookings.some((b) => b.bookingFormEnabled) && (
              <Column
                title="Booking Form"
                dataIndex="bookingForm"
                key="bookingForm"
                render={(_: string, record) => {
                  const isDisabled = !record.bookingFormUrl;
                  return (
                    <a
                      href={record.bookingFormUrl}
                      download
                      onClick={(e) => {
                        if (isDisabled) {
                          e.preventDefault();
                        }
                      }}
                      style={{
                        pointerEvents: isDisabled ? "none" : "auto",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                      }}
                      aria-disabled={isDisabled}
                    >
                      <Icon
                        color={isDisabled ? "#ACACAC" : undefined}
                        path={mdiDownload}
                        size="25px"
                      />
                    </a>
                  );
                }}
              />
            )}
            <Column
              title="Status"
              dataIndex="status"
              key="status"
              fixed="right"
              width={100}
              render={(status: string) => (
                <Tag color={statusesColor[status]} key={status}>
                  {status}
                </Tag>
              )}
            />
            <Column
              title="Action"
              key="action"
              fixed="right"
              width={100}
              render={(_: any, record) => (
                <Space size="middle">
                  <Link to={`/web/bookings/${record.id}`}>View</Link>
                </Space>
              )}
            />
          </Table>
        </div>
      </div>
    );
  }
}

export default BookingsPage;
